import { useAiMastering } from "@/components/pages/ai-mastering/providers/ai-mastering-provider";
import MasteringPlayer from "@/components/pages/ai-mastering/components/mastering-player";
import Loader from "@/components/common/loader";
import downloadIconActive from "@/assets/icons/download-icon-active.svg";
import { aiMasteringLicenseManager } from "@/services/license/license-managers/ai-mastering-license-manager";
import { useProfileContext } from "@/providers/profile-provider/profile-provider";
import { useGlobalModalContext } from "@/providers/modal-provider/modal-provider";

const MasteringResult = () => {
  const { license } = useProfileContext();
  const { showModal } = useGlobalModalContext();
  const { isLoading, masteredTrack } = useAiMastering();

  if (isLoading) {
    return <Loader size={"80px"} />;
  }

  if (!masteredTrack) {
    return <></>;
  }

  const downloadTrack = () => {
    if (
      !aiMasteringLicenseManager.downloadResultLimiter.isDownloadEnabled(
        license,
      )
    ) {
      showModal({
        type: "license_limited_modal",
        props: {
          licenseName: license,
          upgradeToMessage: "AI Mastering",
          allowsMessage: "",
          shouldNavigateToPricing: true,
        },
      });
      return;
    }

    const url = URL.createObjectURL(masteredTrack);
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = masteredTrack.name;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    URL.revokeObjectURL(url);
  };

  return (
    <MasteringPlayer
      trackUrl={URL.createObjectURL(masteredTrack)}
      titles={[masteredTrack.name, "Mastered"]}
      onAction={downloadTrack}
      actionIcon={downloadIconActive}
    />
  );
};

export default MasteringResult;
